import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from 'reactstrap';

interface Props {
  text?: string | null;
  lines?: number;
  className?: string;
}

/**
 * Shows the text clamped to a number of lines and reveals the full text in a tooltip,
 * only when the text is actually cut off.
 */
const TruncatedText: React.FC<Props> = ({ text, lines = 3, className = '' }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (el) {
      setIsTruncated(el.scrollHeight > el.clientHeight + 1);
    }
  }, [text, lines]);

  if (!text) {
    return null;
  }

  return (
    <>
      <div
        ref={ref}
        className={`truncated-text ${className}`}
        style={{ WebkitLineClamp: lines }}
        tabIndex={isTruncated ? 0 : undefined}
        onFocus={() => isTruncated && setOpen(true)}
        onBlur={() => setOpen(false)}
      >
        {text}
      </div>
      {isTruncated && (
        <Tooltip
          placement="top"
          isOpen={open}
          target={ref}
          toggle={() => setOpen(!open)}
          trigger="hover focus"
          className="truncated-text-tooltip"
        >
          {text}
        </Tooltip>
      )}
    </>
  );
};

export default TruncatedText;
